(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-house-measurements]').forEach((panel) => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const toggle = panel.querySelector('[data-measurements-enable]');
      const fields = panel.querySelector('.avk-measurements__fields');
      const sync = () => {
        fields.hidden = !toggle.checked;
        fields.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !toggle.checked;
        });
      };
      toggle.addEventListener('change', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('product:rerender', () => queueMicrotask(() => init()));
})();
